/**
 * WorkContentsであるか
 */
export function isWorkContents(value) {
    return (value != null &&
        Array.isArray(value.workSelections) &&
        value.workSelections.every(isWorkSelection));
}
/**
 * WorkSelectionであるか
 */
export function isWorkSelection(value) {
    return (value != null &&
        typeof value.drillType === 'string' &&
        typeof value.workName === 'string');
}
/**
 * WorkTemplateContentsであるか
 */
export function isWorkTemplateContents(value) {
    return (value != null &&
        Array.isArray(value.workTemplates) &&
        value.workTemplates.every(isWorkTemplateSelection));
}
/**
 * WorkTemplateSelectionであるか
 */
export function isWorkTemplateSelection(value) {
    return (value != null &&
        typeof value.drillType === 'string' &&
        typeof value.templateName === 'string');
}
